import type { ChatDetail, ChatThread } from '../model/types';
import { buildUserPresenceLabel } from './formatParticipantPresence';

export function mergeThreadPresenceFromDetail(
  thread: ChatThread,
  detail: ChatDetail,
  currentUserId: number,
): ChatThread {
  if (thread.id !== detail.id || thread.kind !== 'personal') {
    return thread;
  }

  const peer = detail.participants.find((participant) => participant.user.id !== currentUserId);
  if (!peer) {
    return thread;
  }

  const presence = buildUserPresenceLabel(peer.user);
  if (!presence) {
    return thread;
  }

  const lastSeenAt = peer.user.lastSeenAt ?? null;
  if (
    thread.peerUserId === peer.user.id &&
    thread.online === presence.online &&
    thread.lastSeenLabel === presence.lastSeenLabel &&
    (thread.lastSeenAt?.getTime() ?? null) === (lastSeenAt?.getTime() ?? null)
  ) {
    return thread;
  }

  return {
    ...thread,
    peerUserId: peer.user.id,
    online: presence.online,
    lastSeenAt,
    lastSeenLabel: presence.lastSeenLabel,
  };
}
